"use strict";
/* eslint-disable @typescript-eslint/ban-ts-comment */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importStar(require("react"));
const react_query_1 = require("react-query");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const adminClient_1 = require("client/adminClient");
const UserContext_1 = require("context/UserContext");
const UsersAdminContext_1 = require("context/admin/UsersAdminContext");
const useSelectedUser_1 = require("context/useSelectedUser/useSelectedUser");
const AdvancedFilter_1 = __importDefault(require("components/advance-filter/AdvancedFilter"));
const SelectMemberTable_1 = __importDefault(require("./SelectMemberTable"));
const areEqual = (prevProps, nextProps) => {
    return (0, isEqual_1.default)(prevProps, nextProps);
};
const SelectMemberComponent = react_1.default.memo(({ isCluster = false, isReadOnly = false, withJobPlacement = false, customClass = '', customTableClass = '', handleSet = () => null, setTotalParticipant = () => null, type = 'permission', metadataType = 'totalAvailableUsers', additionalParams }) => {
    const { config } = (0, UserContext_1.useUser)();
    const store = (0, react_1.useContext)(useSelectedUser_1.SelectedUserContext);
    const { totalUser } = (0, UsersAdminContext_1.useUsersAdmin)();
    const _getListFilter = (addedParams) => {
        const fetchFilter = () => {
            return (0, adminClient_1.getListFilter)(addedParams);
        };
        const { data, status, fetchNextPage, isFetchingNextPage } = (0, react_query_1.useInfiniteQuery)(['filter', addedParams], fetchFilter, {
            getNextPageParam: (lastPage) => lastPage.pagination?.next || 0
        });
        return { data, status, isFetchingNextPage, fetchNextPage };
    };
    const getFilterData = async (addedParams) => {
        return await (0, adminClient_1.getListFilter)({ q: addedParams?.q, key: addedParams?.key });
    };
    (0, react_1.useEffect)(() => {
        store?.subscribe(({ selectAll, include, exclude }) => {
            setTotalParticipant(selectAll ? totalUser - exclude.length : include.length);
            handleSet({
                selectAll: selectAll,
                include: include?.map((e) => e?.id),
                exclude: exclude?.map((e) => e?.id)
            });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement("div", { className: customClass },
        react_1.default.createElement(AdvancedFilter_1.default, { filterOptions: ['search', 'menuFilter'], filterMenu: config.generalFilterOptions, filterClient: getFilterData, dialogQueryFn: (params) => _getListFilter(params), id: "selectMemberFilter" },
            react_1.default.createElement(SelectMemberTable_1.default, { isCluster: isCluster, withJobPlacement: withJobPlacement, metadataType: metadataType, additionalParams: additionalParams, type: type, customClass: customTableClass, isReadOnly: isReadOnly }))));
}, areEqual);
SelectMemberComponent.displayName = 'SelectMemberComponent';
exports.default = SelectMemberComponent;
